import * as Yup from 'yup'

import LookupType from './LookupType'

const Recipe = Yup.object().shape({
    id: Yup.number().nullable(),
    product: LookupType.nullable(),
    quantity: Yup.number().nullable().typeError('This must be an integer.')
})

export const PebbleColorSchema = Yup.object().shape({
    selected_color: Yup.object().shape({
        id: Yup.number(),
        name: Yup.string().required('What should we call your concoction?'),
        material_type: LookupType.nullable(),

        recipe: Yup.array().of(Recipe)
    })
})
